import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreNoSearchDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	band: string | null;
	siteType: string | null;
	node: string;
	siteId: string;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	band: null,
	searchValue: '',
	siteId: '',
	siteType: null,
	node: '',
};

const allCells = createSlice({
	name: 'sites',
	initialState,
	reducers: {
		...defaultStoreNoSearchDTO,
		setBand: (state, action: PayloadAction<{ band: string | null }>) => {
			state.band = action.payload.band;
			state.page = initialState.page;
		},
		setSiteType: (state, action: PayloadAction<{ siteType: string | null }>) => {
			state.siteType = action.payload.siteType;
			state.page = initialState.page;
		},
		setNode: (state, action: PayloadAction<{ node: string }>) => {
			state.node = action.payload.node;
			state.searchValue = initialState.searchValue;
			state.siteId = initialState.siteId;
			state.page = initialState.page;
		},
		setSearchValue: (state, action: PayloadAction<{ searchValue: string }>) => {
			state.searchValue = action.payload.searchValue;
			state.siteId = initialState.siteId;
			state.node = initialState.node;
			state.page = initialState.page;
		},
		setSiteId: (state, action: PayloadAction<{ siteId: string }>) => {
			state.siteId = action.payload.siteId;
			state.searchValue = initialState.searchValue;
			state.node = initialState.node;
			state.page = initialState.page;
		},
		resetAllSitesDBTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setBand,
	setSiteType,
	setSearchValue,
	resetAllSitesDBTable,
	setSiteId,
	setNode,
} = allCells.actions;

export default allCells.reducer;
